angular.module('iw.frontyard.translate')
    .filter('iwTranslate', function (Translator, StringHelper) {

        return function (value, options, variables) {
            var adjustedOptions = options || {};
            var adjustedVariables = variables || {};
            var textToTranslate = getTextToTranslate();
            var translation = Translator.translate(textToTranslate);

            if (adjustedOptions.interpolate) {
                translation = Translator.interpolate(translation, adjustedVariables, true);
            }

            if (adjustedOptions.pluralize) {
                return Translator.pluralize(textToTranslate, adjustedOptions.plural, adjustedVariables);
            }

            return translation;

            function getTextToTranslate() {
                if (adjustedOptions.disableTrim !== true) {
                    return StringHelper.trim(value);
                }

                return value;
            }

        };
    });
